import { PageParams, initialPageParams, PageDirection } from 'models/page';
import { ProfileOwnerFormModel } from 'models/user';
import { MedicalOperatorFormModel } from 'models/medicalOperator';
import { PartnerDetailsDTO } from 'models/higoDevice';

export enum PatientStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum PatientType {
  Family = 'FAMILY',
  Pro = 'PRO',
  FamilyAndPro = 'FAMILY_AND_PRO',
}

export enum PatientOrderBy {
  PatientFirstName = 'PATIENT_FIRST_NAME',
  PatientLastName = 'PATIENT_LAST_NAME',
  PatientCreateDate = 'PATIENT_CREATE_DATE',
}

export const patientsInitialPageParams: PageParams & {
  orderBy: PatientOrderBy;
  direction: PageDirection;
} = {
  ...initialPageParams,
  orderBy: PatientOrderBy.PatientCreateDate,
  direction: PageDirection.Desc,
};

export const patientStatusLabelMap = new Map<PatientStatus, string>([
  [PatientStatus.Active, 'status.active'],
  [PatientStatus.Archived, 'status.archived'],
]);

export const patientTypeLabelMap = new Map<PatientType, string>([
  [PatientType.Family, 'mode.family'],
  [PatientType.Pro, 'mode.pro'],
  [PatientType.FamilyAndPro, 'mode.familyAndPro'],
]);

export const patientTypeTagColorMap = new Map<PatientType, string>([
  [PatientType.Family, 'green'],
  [PatientType.Pro, 'cyan'],
  [PatientType.FamilyAndPro, 'purple'],
]);
export interface BusinessPartnerPatientFormModel {
  partner: any;
  dateOfBirth: string;
  firstName: string;
  gender: string;
  id?: number;
  idNumberDocumentType: string;
  idNumber: string;
  lastName: string;
  email?: string;
  phoneNumber: string;
  prefixCode: string;
  assignedMedicalOperator?: MedicalOperatorFormModel;
  assignedFamilyUser?: ProfileOwnerFormModel;
  generalSurveyRequired?: boolean;
}
export interface PatientDTO extends BusinessPartnerPatientFormModel {
  avatarFileId?: number;
  patientStatus: PatientStatus;
  profileColor: string;
  profileUUID: string;
  id: number;
  partnerDetails?: PartnerDetailsDTO;
}

export type Patient = PatientDTO;
